import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SplashScreen.css';
import logo from '../../assets/logo.png';

const SplashScreen = ({ onFinish, duration = 800 }) => {
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();

  console.log('SplashScreen rendering with duration:', duration);

  useEffect(() => {
    console.log('SplashScreen useEffect started');
    // Hide splash after specified duration (default 800ms for loading, 3000ms for initial)
    const timer = setTimeout(() => {
      console.log('SplashScreen timer finished, hiding');
      setIsVisible(false);
      // Wait for fade out animation to complete
      setTimeout(() => {
        console.log('Calling onFinish');
        onFinish();
      }, 500);
    }, duration);

    return () => clearTimeout(timer);
  }, [onFinish, duration]);

  console.log('SplashScreen isVisible:', isVisible);
  if (!isVisible) return null;

  return (
    <div className="splash-screen">
      <div className="splash-content">
        <img 
          src={logo} 
          alt="UniTrade Logo" 
          className="splash-logo"
        />
        <div className="splash-loader">
          <div className="splash-spinner"></div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
